import React from 'react';
import { Platform, View, Dimensions } from 'react-native';

import { IWebWrapper } from './interfaces';

const WebWrapper = ({ children, webWrapperStyes }: IWebWrapper) => {
  const { width } = Dimensions.get('window');
  if (Platform.OS !== 'web') return <>{children}</>;

  return (
    <View
      style={[
        {
          width,
          alignSelf: 'center',
          maxWidth: 768,
        },
        webWrapperStyes,
      ]}
    >
      {children}
    </View>
  );
};

export default WebWrapper;
